export default {
  parent_profile: () => '/account/profile',
  finish_signup: () => '/auth/finish-signup',
  shared_presetations: () => '/auth/finish-signup',
  oauth_identity_connected: () => '/account/profile',
  oauth_identity_removed: () => '/auth',
  assessment_files: params =>
    `/moderation/assessment-files/${params.assessment_file_id}`
}
